import { AfterViewInit, Component, ElementRef, Inject, Input, NgZone, OnDestroy, OnInit, PLATFORM_ID, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CartService } from '@services/cart.service';
import { WishlistService } from '@services/wishlist.service';
import { RootService } from '@services/root.service';
import { HeaderService } from '@services/header.service';
import { fromEvent, merge, Observable, Subject } from 'rxjs';
import { filter, first, map, shareReplay, take, takeUntil } from 'rxjs/operators';
import { fromMatchMedia } from '@shared/functions/rxjs/fromMatchMedia';
import { isPlatformBrowser, NgClass, NgIf, AsyncPipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router, UrlSerializer, RouterLink } from '@angular/router';
import { DropcartType, DropcartComponent } from '../dropcart/dropcart.component';
import { OffcanvasCartService } from '@services/offcanvas-cart.service';
import { QuotationCartService } from '@app/_services/quotation.service';
import { TranslateService } from '@ngx-translate/core';
import { DirectionService } from '@app/_services/direction.service';
import * as _ from 'lodash' ;
import { state } from '@angular/animations';
import { AuthenticationService, UserService } from '@app/_services';
import { SharedService } from '@app/_services/shared.service';
import { AccountMenuComponent } from '../account-menu/account-menu.component';
import { SearchComponent } from '../../../../shared/components/search/search.component';
import { IndicatorComponent } from '../indicator/indicator.component';

export type NavStickyMode = 'alwaysOnTop' | 'pullToShow';

@Component({
    selector: 'app-header-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    providers: [UserService],
    standalone: true,
    imports: [NgClass, NgIf, RouterLink, IndicatorComponent, SearchComponent, DropcartComponent, AccountMenuComponent, AsyncPipe]
})
export class NavComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() departments = true;
    @Input() logo = false;
    @Input() search = false;
    @Input() stickyMode: NavStickyMode | false = false;

    @ViewChild('element') elementRef: ElementRef;

    destroy$: Subject<void> = new Subject<void>();

    stuckFrom = null;
    staticFrom = null;
    scrollPosition = 0;
    scrollDistance = 0;
    hideSearch = true;

    isBrowser = true;
    media: Observable<MediaQueryList>;

    dropcartType: DropcartType;

    get element(): HTMLDivElement {
        return this.elementRef?.nativeElement;
    }

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private sharedService: SharedService,
        private route: ActivatedRoute,
        private offcanvasCart: OffcanvasCartService,
        public root: RootService,
        public cart: CartService,
        public quotationCart: QuotationCartService,
        public wishlist: WishlistService,
        public zone: NgZone,
        public header: HeaderService,
        public translateService: TranslateService,
        private router: Router,
        private direction: DirectionService,
        private urlSerializer: UrlSerializer,
        private userService: UserService,
        private authService: AuthenticationService,
        private cd : ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.sharedService.page$.subscribe(page => {
            if (page == "homepage") {
                this.departments = false;
                this.cd.detectChanges();
            }
            else {
                this.departments = true;
            }
        });
    }

    changeLangage(lang: string) {
        this.authService.currentUser.subscribe((user : any): any => {
            if (user?.preferances?.language != lang)
                this.userService.setLanguage({lang:lang}).subscribe((res)=>{
                    if (res.code == 200){

                        this.translateService.use(lang);

                        let navigationExtras: NavigationExtras;
                
                        const tree = this.router.parseUrl(this.router.url);
                
                        let url: any = this.urlSerializer.parse(this.router.url);
                
                        let stateUrl = this.router.url.split('/');
                        let commands = [];
                
                        stateUrl.forEach((segment)=>{
                            if (segment == "" || segment == "en" || segment == "ar" ) return;
                
                            if (segment.includes('?')) {
                                commands.push(segment.split('?')[0]);
                                if(!_.isEmpty(url.queryParams) || !_.isEmpty(tree.queryParams)) {
                                    //commands.push({queryParams: url.queryParams??tree.queryParams});
                                    navigationExtras = {
                                        queryParams: url.queryParams??tree.queryParams
                                      };
                                }
                
                            } else {
                                commands.push(segment);
                            }
                
                        });
                
                        commands.unshift('/'.concat(lang))
                
                        this.router.navigate(commands, navigationExtras);
                
                        lang == 'ar'? this.direction.value = 'rtl': 'ltr';
                    } else {
                    //console.log("Error setting user prefered language");
                    }

                },(error)=>{
                //console.log("Error setting user prefered language");
                });
            });


    }

    ngOnInit() {
        this.route.data.subscribe(data => {
            this.dropcartType = data.dropcartType || 'dropdown';
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewInit(): void {
        if (this.stickyMode && isPlatformBrowser(this.platformId)) {
            this.media = fromMatchMedia('(min-width: 992px)', false).pipe(shareReplay({ bufferSize: 1, refCount: true }));
            this.media.pipe(takeUntil(this.destroy$)).subscribe(media => this.onMediaChange(media));
        }
    }

    onCartClick(): void {
        if (this.dropcartType === 'offcanvas') {
            this.offcanvasCart.open();
        }
    }

    onScroll(): void {
        const scrollCurrentPosition = window.pageYOffset;
        const scrollDelta = scrollCurrentPosition - this.scrollPosition;

        // Resets the distance if the scroll changes direction.
        if ((scrollDelta < 0) !== (this.scrollDistance < 0)) {
            this.scrollDistance = 0;
        }

        const distanceToShow = 10; // in pixels
        const distanceToHide = 25; // in pixels

        this.scrollPosition = scrollCurrentPosition;
        this.scrollDistance += scrollDelta;
        if (this.scrollDistance >= distanceToShow) {

        } else {

        }

        if (this.header.navPanelPosition === 'static' && scrollCurrentPosition > this.stuckFrom) {
            this.makeSticky();
        }
        if (this.header.navPanelPosition === 'sticky' && scrollCurrentPosition <= this.staticFrom) {
            this.hideSearch = true;
            this.makeStatic();
        }

        if (this.header.navPanelPosition === 'sticky') {
            if (this.stickyMode === 'pullToShow') {
                if (this.scrollDistance <= -distanceToShow && this.header.navPanelVisibility === 'hidden') {
                    this.show();
                }
                if (this.scrollDistance >= distanceToHide && this.header.navPanelVisibility === 'shown') {
                    this.hide();
                }
            } else if (this.stickyMode === 'alwaysOnTop' && this.header.navPanelVisibility === 'hidden') {
                this.hideSearch = false;
                this.show();
            }
        }
    }

    onMediaChange(media: MediaQueryList): void {
        if (media.matches) {
            const takeUntil$ = merge(
                this.media.pipe(filter(x => !x.matches), first()),
                this.destroy$,
            );

            this.header.departmentsArea$.pipe(
                takeUntil(takeUntil$)
            ).subscribe(() => setTimeout(() => this.calcBreakpoints(), 0));

            this.zone.runOutsideAngular(() => {
                fromEvent(window, 'scroll', { passive: true }).pipe(
                    takeUntil(takeUntil$)
                ).subscribe(() => this.onScroll());
            });

            this.calcBreakpoints();
        } else {
            this.makeStatic();
        }
    }

    calcBreakpoints(): void {
        if(!this.isBrowser) return;
        if (this.header.departmentsArea) {
            const rect = this.header.departmentsArea.getBoundingClientRect();

            this.stuckFrom = rect.top + rect.height + window.screenTop + 50 + window.pageYOffset;
            this.staticFrom = this.stuckFrom;
        } else {
            const elementRect = this.element.getBoundingClientRect();

            this.staticFrom = elementRect.top + window.pageYOffset;
            this.stuckFrom = elementRect.top + elementRect.height + window.pageYOffset;
        }
    }

    private makeStatic(): void {
        this.element.classList.remove('nav-panel--stuck');
        this.element.classList.remove('nav-panel--shown');

        this.element.style.transition = 'none';
        if(this.isBrowser) this.element.getBoundingClientRect(); // force reflow
        this.element.style.transition = '';

        this.zone.run(() => this.header.navPanelPosition = 'static');
        this.zone.run(() => this.header.navPanelVisibility = 'hidden');
    }

    private makeSticky(): void {
        this.element.classList.add('nav-panel--stuck');

        this.element.style.transition = 'none';
        if(this.isBrowser) this.element.getBoundingClientRect(); // force reflow
        this.element.style.transition = '';

        this.zone.run(() => this.header.navPanelPosition = 'sticky');
    }

    private show(): void {
        this.element.classList.add('nav-panel--shown');

        this.zone.run(() => this.header.navPanelVisibility = 'shown');
    }

    private hide(): void {
        this.element.classList.remove('nav-panel--shown');

        this.zone.run(() => this.header.navPanelVisibility = 'hidden');
    }
}
